import { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  completed: boolean;
};

export const GeneratedChapterStatusBadge: FC<Props> = ({ completed }) => {
  const { t } = useTranslation();

  const status = completed
    ? t("generatedChapter.validated")
    : t("generatedChapter.non_validated");

  const color = completed ? "herb" : "sand";

  const colorVariants = {
    herb: "bg-herb-10 text-herb-700",
    sand: "bg-sand-10 text-sand-700",
  };

  return (
    <span
      className={[
        "px-1.5 sm:px-2 py-1 inline-flex text-xs sm:text-sm leading-4 sm:leading-5 font-semibold rounded-full",
        colorVariants[color],
      ].join(" ")}
    >
      {status}
    </span>
  );
};
